export { default } from "./successInfoBox";
